<div *ngIf="show" class="preloader" [ngClass]="classes">
    <span class="icon icon-ag-spinner"></span>
    <span *ngIf="text" class="progress-text" [innerHTML]="label | translate ">
        Loading! Please wait...
    </span>
</div>
